import { FHIR_DEFAULT_PAGE_URL, FHIR_DEFAULT_PAGE_URL_FULL_SITE, FhirService } from './../../service/fhir.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../authentication/authentication.service';
import { User } from 'src/app/user/model/user';
import { SelectRoleComponent } from 'src/app/shared/select-role/select-role.component';
import { SelectOrganizationComponent } from 'src/app/shared/select-organization/select-organization.component';

@Component({
  selector: 'app-smart-redirect',
  templateUrl: './smart-redirect.component.html',
  styleUrls: ['./smart-redirect.component.scss']
})
export class SmartRedirectComponent implements OnInit
{
  @ViewChild('selectRole') public selectRole: SelectRoleComponent;
  @ViewChild('selectOrganization') public selectOrganization: SelectOrganizationComponent;

  public code = null;
  public state = null;
  public lastError: string = undefined;
  public errors = Object.freeze({
    invalidParams: 'invalidParams',
    invalidState: 'invalidState',
    invalidTokenResponse: 'invalidTokenResponse',
    errorTokenRequest: 'errorTokenRequest',
    errorProfileCheck: 'errorProfileCheck',
    invalidAuth: 'invalidAuth',
    invalidAuthToken: 'invalidAuthToken'
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private fhirService: FhirService) { }

  public ngOnInit(): void
  {
    this.init();
    this.parseParams();
  }

  private parseParams(): void
  {
    this.route.queryParamMap.forEach(n =>
    {
      n.keys.forEach(key =>
      {
        switch (key)
        {
          case 'code':
            this.code = n.get(key);
            break;
          case 'state':
            this.state = n.get(key);
            break;
        }
      });
    });

    const fhirAuthRequest = this.fhirService.fhirAuthRequest;
    if (!this.code || !this.state || !fhirAuthRequest)
    {
      this.lastError = this.errors.invalidParams;
    }
    else
    {
      // Validate State
      if (fhirAuthRequest.state !== this.state)
      {
        this.lastError = this.errors.invalidState;
      }
      else
      {
        this.fhirService.callTokenEndpoint(this.code).subscribe({
          next: (tokenResponse: any) =>
          {
            // If no token reponse that means we can't get the token or wrong signature
            if (tokenResponse === null)
            {
              this.lastError = this.errors.invalidAuthToken;
            }
            else
            {
              this.fhirService.oAuthTokenSave(tokenResponse);

              if (!this.fhirService.oAuthToken || !this.fhirService.oAuthToken.user)
              {
                this.lastError = this.errors.invalidTokenResponse;
              }
              else
              {
                this.fhirService.existsIssuerProfile().subscribe({
                  next: (issuerProfile: any) =>
                  {
                    // If userId is found, we will authenticate using SSO
                    if (issuerProfile && issuerProfile.userId)
                    {
                      this.authService.authenticate(null, null, issuerProfile.selectedLanguage).subscribe({
                        next: (data) =>
                        {
                          const authenticatedUser = data as User;
                          if (!authenticatedUser.enabled)
                          {
                            this.lastError = this.errors.invalidAuth;
                          }
                          else
                          {
                            let returnUrl = null;
                            if (this.fhirService.fullSite)
                            {
                              returnUrl = FHIR_DEFAULT_PAGE_URL_FULL_SITE;
                            }
                            else
                            {
                              returnUrl = FHIR_DEFAULT_PAGE_URL;
                            }
                            this.authService.login(authenticatedUser, returnUrl, this.selectRole, this.selectOrganization, null, true);
                          }
                        },
                        error: () =>
                        {
                          this.lastError = this.errors.invalidAuth;
                        }
                      });
                    }
                    else
                    {
                      // Redirect for a first login                      
                      if (this.fhirService.fullSite)
                      {
                        this.router.navigateByUrl(`/login?return=${FHIR_DEFAULT_PAGE_URL_FULL_SITE}`);
                      }
                      else
                      {
                        this.router.navigateByUrl(`/login?return=${FHIR_DEFAULT_PAGE_URL}`);
                      }                                            
                    }
                  },
                  error: () =>
                  {
                    this.lastError = this.errors.errorProfileCheck;
                  }
                });
              }
            }
          },
          error: () =>
          {
            this.lastError = this.errors.errorTokenRequest;
          }
        });
      }
    }
  }

  private init(): void
  {
    this.code = null;
    this.state = null;
    this.lastError = undefined;
  }
}
